import { render, staticRenderFns } from "./ServicePages.vue?vue&type=template&id=593f0ffe&scoped=true"
import script from "./ServicePages.vue?vue&type=script&lang=js"
export * from "./ServicePages.vue?vue&type=script&lang=js"
import style0 from "./ServicePages.vue?vue&type=style&index=0&id=593f0ffe&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593f0ffe",
  null
  
)

export default component.exports